import React, { useState, useEffect } from "react";
import { Box, Button, Typography } from '@mui/material';
import { CustomTab, CustomTabs } from "../common/custom-tabs.component";
import useWidth from "../../hooks/useWidth";
import ReportsThreeComponent from "./report-three.component";
import ReportsTwoComponent from "./report-two.component";
import ReportsFourComponent from "./report-four.component";

import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";



function useReportsTab(props) {

    const { selectedProject, selected_business } = props;

    const [reports_tab, setReportsTabs] = useState(null);



    function setupTabs() {

        var tabs_default = [
            { name: 'Date', component: <ReportsTwoComponent selectedProject={selectedProject && selectedProject} selected_business={selected_business} /> },
            { name: 'Pipelines', component: <ReportsFourComponent  selectedProject={selectedProject && selectedProject} selected_business={selected_business}/> },
            { name: 'Transactions', component: <ReportsThreeComponent   selectedProject={selectedProject && selectedProject} selected_business={selected_business} /> },
        
        ]

        setReportsTabs(tabs_default);
    }

    useEffect(() => { setupTabs(); }, [])

    return reports_tab;

}


function ReportsTabsComponent(props) {

    const  { business_id,project_id, selectedProject, selected_business } = props;

  const tabs = useReportsTab({business_id,project_id, selectedProject, selected_business});

  const breakpoints = useWidth();

  const storedTab = localStorage.getItem('selectedTab');
  const initialTabValue = storedTab ? parseInt(storedTab) : 0;
  const [value, setValue] = useState(initialTabValue);

  useEffect(() => {
    return () => {
      localStorage.removeItem('selectedTab');
    };
  }, []);

  function TabPanel(props) {

    const { children, value, index, ...other } = props;


    return (
      <div
        component="div"
        role="tabpanel"
        hidden={value !== index}
        id={`scrollable-auto-tabpanel-${index}`}
        aria-labelledby={`scrollable-auto-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  function a11yProps(index) {
    return {
      id: `scrollable-auto-tab-${index}`,
      'aria-controls': `scrollable-auto-tabpanel-${index}`,
    };
  }


  function handleChange(event, newValue) {
    setValue(newValue);
    localStorage.setItem('selectedTab', newValue); // Store selected tab index
  }
  



  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <CustomTabs
          variant="scrollable"
          value={value}
          onChange={handleChange}
          sx={{ marginTop: 2 }}
          indicatorColor="transparent"
          centered
        >
          {tabs?.map((tab, index) => {
            return (
              <CustomTab label={tab.name} disableRipple {...a11yProps(index)} />
            )
          })
          }
        </CustomTabs>
       
      </Box>


      {tabs?.map((tab, index) => {
        return (
          <TabPanel value={value} index={index} style={{ padding: "0px" }}>
            {tab.component}
          </TabPanel>
        )
      })
      }

    
    </Box>
  )
}

export default ReportsTabsComponent;